/**
 * BillType: Defines different billing methods for calculating messaging volume.
 *
 * Used in:
 * - Org.defaultBillType: Specifies the preferred billing method for an org
 * - Billing.volumeSource: Records how volume was actually fetched for a bill
 *
 * Values:
 * - standard: Excludes 'failed' and 'waiting' status (current method)
 * - conservative: Excludes 'failed', 'waiting', and 'sent' status (only delivered/read)
 * - karix: Fetches volume from uploaded Karix CSV data
 */
export enum BillType {
  STANDARD = 'standard',
  CONSERVATIVE = 'conservative',
  KARIX = 'karix',
}
